<ng-container *ngIf="kpiUser">
  <h2 class="offset-1 text-white mb-3 mt-3 text-white">Utilisateurs</h2>
  <div class="row">
    <div [class]="cardClass">
      <app-kpi
        icon="people_alt"
        title="Total Utilisateurs"
        [value]="kpiUser.total"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="total"
        [main]="true"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="person"
        title="Particuliers"
        [value]="kpiUser.nbIndividual"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="nbIndividual"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="badge"
        title="Pros de l'immobilier"
        [value]="kpiUser.nbRealEstatePro"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="nbRealEstatePro"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="how_to_reg"
        title="Utilisateurs actifs"
        details="Ces 30 derniers jours"
        [value]="kpiUser.active"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="active"
        [main]="true"
      >
      </app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="how_to_reg"
        title="Agents actifs"
        details="Ces 30 derniers jours"
        [value]="kpiUser.activeRealtor"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="activeRealtor"
      >
      </app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="how_to_reg"
        title="Particuliers actifs"
        details="Ces 30 derniers jours"
        [value]="kpiUser.activeIndividual"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="activeIndividual"
      >
      </app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="how_to_reg"
        title="Notaires actifs"
        details="Ces 30 derniers jours"
        [value]="kpiUser.activeNotary"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="activeNotary"
      >
      </app-kpi>
    </div>

    <div [class]="cardClass">
      <app-kpi
        icon="login"
        title="Total connexions"
        details="Aujourd'hui"
        [value]="kpiUser.nbConnectionsToday"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="nbConnectionsToday"
        [main]="true"
      >
      </app-kpi>
    </div>

    <div [class]="cardClass">
      <app-kpi
        icon="login"
        title="Connexions agents"
        details="Aujourd'hui"
        [value]="kpiUser.nbConnectionsTodayRealtor"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="nbConnectionsTodayRealtor"
      >
      </app-kpi>
    </div>

    <div [class]="cardClass">
      <app-kpi
        icon="login"
        title="Connexions Particuliers"
        details="Aujourd'hui"
        [value]="kpiUser.nbConnectionsTodayIndividual"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="nbConnectionsTodayIndividual"
      >
      </app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="login"
        title="Connexions notaires"
        details="Aujourd'hui"
        [value]="kpiUser.nbConnectionsTodayNotary"
        historyApiFunction="getKpiUsersHistory"
        historyApiField="nbConnectionsTodayNotary"
      >
      </app-kpi>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="kpiSubscription">
  <h2 class="offset-1 text-white mb-3 mt-3 text-white">Abonnements</h2>
  <div class="row">
    <div [class]="cardClass">
      <app-kpi
        icon="workspace_premium"
        title="Total"
        details="+{{ kpiSubscription.newToday }} aujourd'hui"
        [value]="kpiSubscription.activeTotal"
        historyApiFunction="getKpiSubscriptionHistory"
        historyApiField="activeTotal"
        [main]="true"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="task_alt"
        title="Mensuels"
        [value]="kpiSubscription.activeMontlhy"
        historyApiFunction="getKpiSubscriptionHistory"
        historyApiField="activeMontlhy"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="task_alt"
        title="Annuels"
        [value]="kpiSubscription.activeYearly"
        historyApiFunction="getKpiSubscriptionHistory"
        historyApiField="activeYearly"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="store"
        title="Via Agences"
        [value]="kpiSubscription.activeAgency"
        historyApiFunction="getKpiSubscriptionHistory"
        historyApiField="activeAgency"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="psychology"
        title="Essais en cours"
        [value]="kpiSubscription.trialing"
        historyApiFunction="getKpiSubscriptionHistory"
        historyApiField="trialing"
        [main]="true"
      ></app-kpi>
    </div>
    <!--<div [class]="cardClass">
      <app-kpi icon="schedule" title="Suspendus" [value]="kpiSubscription.suspended"></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi icon="unpublished" title="Expirés" details="" [value]="kpiSubscription.expired">
      </app-kpi>
    </div>-->
    <div [class]="cardClass">
      <app-kpi
        icon="euro"
        title="CA Mois en cours"
        details="TTC"
        [value]="kpiSubscription.revenueThisMonth"
        historyApiFunction="getKpiSubscriptionHistory"
        historyApiField="revenueThisMonth"
        [main]="true"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="euro"
        title="CA Mois dernier"
        details="TTC"
        [value]="kpiSubscription.revenueLastMonth"
        historyApiFunction="getKpiSubscriptionHistory"
        historyApiField="revenueLastMonth"
      ></app-kpi>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="kpiPropertyShare">
  <h2 class="offset-1 text-white mb-3 mt-3 text-white">Partages</h2>
  <div class="row">
    <div [class]="cardClass">
      <app-kpi
        icon="share"
        title="Actifs"
        [value]="kpiPropertyShare.active"
        historyApiFunction="getKpiPropertySharesHistory"
        historyApiField="active"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="person_add_alt"
        title="Créés"
        details="Ces 30 derniers jours"
        [value]="kpiPropertyShare.created"
        historyApiFunction="getKpiPropertySharesHistory"
        historyApiField="created"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="percent"
        title="Taux de consultation"
        details="Ces 30 derniers jours"
        [value]="kpiPropertyShare.consultationRate"
        historyApiFunction="getKpiPropertySharesHistory"
        historyApiField="consultationRate"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="percent"
        title="Taux de consultation abonnés"
        details="Ces 30 derniers jours"
        [value]="kpiPropertyShare.consultationRateSubscribers"
        historyApiFunction="getKpiPropertySharesHistory"
        historyApiField="consultationRateSubscribers"
        [main]="true"
      ></app-kpi>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="kpiProperty">
  <h2 class="offset-1 text-white mb-3 mt-3 text-white">Biens</h2>
  <div class="row">
    <div [class]="cardClass">
      <app-kpi
        icon="house"
        title="Biens enregistrés"
        [value]="kpiProperty.total"
        historyApiFunction="getKpiPropertiesHistory"
        historyApiField="total"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="verified_user"
        title="Biens certifiés"
        [value]="kpiProperty.certified"
        historyApiFunction="getKpiPropertiesHistory"
        historyApiField="certified"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="loop"
        title="Certifications en cours"
        [value]="kpiProperty.request"
        historyApiFunction="getKpiPropertiesHistory"
        historyApiField="request"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="menu_book"
        title="CIL validés"
        [value]="kpiProperty.bookletValidated"
        historyApiFunction="getKpiPropertiesHistory"
        historyApiField="bookletValidated"
        [main]="true"
      ></app-kpi>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="kpiPropertySale">
  <h2 class="offset-1 text-white mb-3 mt-3 text-white">Ventes</h2>
  <div class="row">
    <div [class]="cardClass">
      <app-kpi
        icon="real_estate_agent"
        title="Biens à vendre"
        [value]="kpiPropertySale.selling"
        historyApiFunction="getKpiPropertySalesHistory"
        historyApiField="selling"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="currency_exchange"
        title="Ventes en cours"
        [value]="kpiPropertySale.onGoing"
        historyApiFunction="getKpiPropertySalesHistory"
        historyApiField="onGoing"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="attach_money"
        title="Ventes signées"
        [value]="kpiPropertySale.sold"
        historyApiFunction="getKpiPropertySalesHistory"
        historyApiField="sold"
        [main]="true"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="money_off"
        title="Ventes annulées"
        [value]="kpiPropertySale.canceled"
        historyApiFunction="getKpiPropertySalesHistory"
        historyApiField="canceled"
      ></app-kpi>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="kpiCompany">
  <h2 class="offset-1 text-white mb-3 mt-3 text-white">Partenaires</h2>
  <div class="row">
    <div [class]="cardClass">
      <app-kpi
        icon="handshake"
        title="Partenaires"
        [value]="kpiCompany.total"
        historyApiFunction="getKpiCompaniesHistory"
        historyApiField="total"
      ></app-kpi>
    </div>
  </div>
</ng-container>
